module.exports = __webpack_public_path__ + "static/img/manual_zh_9.9c5f9cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_9.png
// module id = EoLy
// module chunks = 4